// 高德地图统一配置
// key 与安全密钥优先读取环境变量，未配置时回退到默认值
export var AMAP_CONFIG = {
  key: 'cce93bb309bf39f2c117cc24dba92e7d',
  securityJsCode: '13b215e0fa97e4fa07afe518a4156db9'
};
var loadPromise = null;

/**
 * 动态加载高德地图 JS SDK（单例，多次调用复用同一 Promise）
 * @param {string} plugins 需要加载的插件，逗号分隔
 * @returns {Promise<void>}
 */
export function loadAMap() {
  var plugins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'AMap.PlaceSearch,AMap.Geocoder';
  if (window.AMap) return Promise.resolve();
  if (loadPromise) return loadPromise;
  loadPromise = new Promise(function (resolve, reject) {
    window._AMapSecurityConfig = {
      securityJsCode: AMAP_CONFIG.securityJsCode
    };
    var script = document.createElement('script');
    script.src = "https://webapi.amap.com/maps?v=2.0&key=".concat(AMAP_CONFIG.key, "&plugin=").concat(plugins);
    script.onload = function () {
      return resolve();
    };
    script.onerror = function () {
      loadPromise = null;
      reject(new Error('地图加载失败'));
    };
    document.head.appendChild(script);
  });
  return loadPromise;
}